<app-layout>
  <!-- <app-home-main-banner-slider></app-home-main-banner-slider> -->
  <div class="container-fluid p-0">
    <div class="banner-container d-flex justify-content-center align-items-center">
      <div class="banner-blur container-fluid"></div>
      <img class="banner-image-home" src="./../../../../assets/images/banner-home-topo-diga-yes.jpg" alt="" />
    </div>
    @defer (on idle) {
      <app-category-carousel></app-category-carousel>
    } @placeholder {
      <div class="carousel-placeholder"></div>
    }
    @defer (on idle) {
      <app-home-carousel-events></app-home-carousel-events>
    } @placeholder {
      <div class="carousel-placeholder"></div>
    }
    <!-- <app-slider-events-call-to-action></app-slider-events-call-to-action> -->
    <app-call-to-action-pay-in-installments-by-credit-card></app-call-to-action-pay-in-installments-by-credit-card>
    <app-call-to-action-register></app-call-to-action-register>
  </div>
</app-layout>
